export const MOBILE_MD = "600px";
export const MOBILE_LG = "900px";
export const LAPTOP_SM = "1090px";
export const LAPTOP = "1300px";
